var photoUploader = {
    bindings : {
        addMsg: '&',
        photoUploaderModel: '='
    },
    /**
     * @ngInject
     */
    controller : function PhotoUploaderCtrl ($scope, $rootScope, $element, $sce) {
        
        var ctrl = this;
        ctrl.processing = false;
        var photo = {};

        function init () {
            // console.log("photoUploaderCtrl::init", ctrl.photoUploaderModel, photo);

            if(angular.isDefined(ctrl.photoUploaderModel)){
                ctrl.preview = ctrl.photoUploaderModel.photo;
            }
        }

        function link () {
            var handler = function (e) {
                $scope.$apply(function () {
                    ctrl.fileChanged(e);
                });
            };

            // Attach the handler to the HTML change event 
            $element[0].addEventListener('change', handler, false);
        }

        ctrl.fileChanged = function fileChanged(e){
            // console.log("file_changed: ",  e.target.files);

            ctrl.processing = true;
            // if (!$scope.$$phase) $scope.$digest();
            // if (!$rootScope.$$phase) $rootScope.$digest();

            var file = e.target.files[0];



            loadImage.parseMetaData(
                file,
                function (data) {
                    if (!data.imageHead) {
                        return;
                    }
                    // Combine data.imageHead with the image body of a resized file
                    // to create scaled images with the original image meta data, e.g.:
                    var orientation = data.exif.get('Orientation');
                    var isIos = /iPad|iPhone|iPod/.test(navigator.userAgent);
                    // console.log("Orientation:",orientation, data);
                    // console.log("isIos:",isIos);
                    var orientationTransforms = {
                        0 : '',
                        1 : '',
                        2 : 'transform: rotateY(180deg)',
                        3 : 'transform: rotate(180deg)',
                        4 : 'transform: rotate(180deg) rotateY(180deg)',
                        5 : 'transform: rotate(270deg) rotateY(180deg)',
                        6 : 'transform: rotate(90deg)',
                        7 : 'transform: rotate(90deg) rotateY(180deg)',
                        8 : 'transform: rotate(270deg)'
                    };
                    ctrl.orientation = orientation;
                    ctrl.previewTransform = isIos ? '' : orientationTransforms[orientation];
                    // console.log("previewTransform: ",ctrl.previewTransform);

                },
                {
                    maxMetaDataSize: 262144,
                    disableImageHead: false,
                    orientation: true
                }
            );

            
            var reader = new FileReader();
            // Closure to capture the file information.
            reader.onload = (function(theFile) {
                return function(e) {
                    // Render thumbnail.
                    // $('.photoUploader__preview').attr('src',e.target.result); // TODO
                    photo = e.target.result;
                    
                    // Split base64 string and repo intro-stub
                    var base64image = photo.split(",");
                    ctrl.photoUploaderModel = {
                        'base64type' : base64image[0],
                        'base64data' : base64image[1],
                        'type' : file.type,
                        'size' : file.size,
                        'name' : file.name,
                        'orientation' : ctrl.orientation,
                    };
                    ctrl.preview = ctrl.photoUploaderModel.base64type + "," + ctrl.photoUploaderModel.base64data;
                    ctrl.processing = false;
                    // console.log(ctrl.photoUploaderModel);
                    if (!$scope.$$phase) $scope.$digest();
                    if (!$rootScope.$$phase) $rootScope.$digest();

                };
            })(file);
            // Read in the image file as a data URL.
            reader.readAsDataURL(file);

            ctrl.addMsg({
                $event: {
                    content: $sce.trustAsHtml('Flot billede! 💪'),
                    type: 'receive'
                }
            });

        };

        // ctrl.removePhoto = function removePhoto(){
        //     console.log("photoUploaderCtrl.removePhoto");
        //     ctrl.photoUploaderModel = {};
        //     ctrl.preview = "";
        //     document.querySelector(".photoUploader__input").value = "";
        // };

        ctrl.$onInit = init;
        ctrl.$postLink = link;
    },
    templateUrl : './angular/components/photo-uploader.component.html'
};